import { Component } from "@angular/core";

@Component({
    selector: "spinner",
    styles: [".mat-mdc-progress-spinner { margin: 0 auto; }"],
    template: `<mat-spinner role="alert" aria-busy="true" aria-live="assertive"></mat-spinner>`
})
export class SpinnerComponent {}
